import React, { useState } from "react";
import { Text } from "@/styles/reactnative";
import MarketTrendTabs from "../../MarketTrendTabs";
import CryptoTradingGraph from "./CryptoTradingGraph";
import CryptoTradingFooter from "./CryptoTradingFooter";
import {
  CryptoCurrencyTrendHeader,
  CryptoCurrencyTrendSection,
} from "../styles";
import { useTranslation } from "react-i18next";

const CryptoTrading = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("7d");
  const tabs = ["7d", "1m", "3m", "6m", "1y"];
  return (
    <CryptoCurrencyTrendSection>
      <CryptoCurrencyTrendHeader>
        <Text size={16} style={{ fontWeight: "600" }}>
          {t("tradingVolumeDistribution")}
        </Text>
        <MarketTrendTabs tab={tab} setTab={setTab} tabs={tabs} />
      </CryptoCurrencyTrendHeader>
      <CryptoTradingGraph />
      <CryptoTradingFooter />
    </CryptoCurrencyTrendSection>
  );
};

export default React.memo(CryptoTrading);
